import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';

export default function AdminDashboardSettings() {
  const { csrfToken } = useAuth();
  const [siteTitle, setSiteTitle] = useState('');
  const [themeColor, setThemeColor] = useState('#0d47a1');
  const [footerText, setFooterText] = useState('');
  const [message, setMessage] = useState(null);

  // بارگذاری تنظیمات فعلی از سرور
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get('/admin/settings', {
          headers: { 'X-CSRF-Token': csrfToken }
        });
        setSiteTitle(data.siteTitle || '');
        setThemeColor(data.themeColor || '#0d47a1');
        setFooterText(data.footerText || '');
      } catch (err) {
        console.error("Error loading settings:", err);
      }
    })();
  }, [csrfToken]);

  // ذخیره تنظیمات
  const handleSave = async () => {
    try {
      await axios.post('/admin/settings', {
        siteTitle,
        themeColor,
        footerText
      }, {
        headers: { 'X-CSRF-Token': csrfToken }
      });
      setMessage("Settings saved successfully ✅");
    } catch (err) {
      setMessage("Error saving settings ❌");
    }
  };

  return (
    <div className="container py-5">
      <h1 className="h4 mb-4">Site Settings</h1>

      {message && <div className="alert alert-info">{message}</div>}

      {/* Site Title */}
      <div className="mb-3">
        <label className="form-label">Site Title</label>
        <input
          className="form-control"
          value={siteTitle}
          onChange={e => setSiteTitle(e.target.value)}
        />
      </div>

      {/* Theme Color */}
      <div className="mb-3">
        <label className="form-label">Theme Color</label>
        <input
          type="color"
          className="form-control form-control-color"
          value={themeColor}
          onChange={e => setThemeColor(e.target.value)}
        />
      </div>

      {/* Footer Text */}
      <div className="mb-3">
        <label className="form-label">Footer Text</label>
        <input
          className="form-control"
          value={footerText}
          onChange={e => setFooterText(e.target.value)}
        />
      </div>

      <button className="btn btn-warning mt-3" onClick={handleSave}>
        Save Settings
      </button>
    </div>
  );
}
